import { createCartazoClient } from '@cartazo/sdk'

/**
 * Cliente de la API para la carta.
 *
 * En desarrollo, Vite hace de proxy de `/v1` hacia la consola, así que la ruta
 * relativa funciona igual en ambos entornos y no hay CORS que configurar.
 */
export const apiBaseUrl: string = import.meta.env.VITE_API_URL ?? '/v1'

export const api = createCartazoClient({
  baseUrl: apiBaseUrl,
  // Diez segundos: un comensal en un sótano con una barra de cobertura no puede
  // quedarse esperando. Si expira, tiramos de la copia del Service Worker.
  timeoutMs: 10_000,
})

const SESSION_KEY = 'cartazo:session'

/**
 * Identificador anónimo de sesión para la analítica.
 *
 * Vive en `sessionStorage`, no en `localStorage`: muere al cerrar la pestaña.
 * No es un identificador de persona y no debe convertirse en uno — la carta no
 * tiene login y no queremos poder reconstruir el historial de nadie.
 */
export function sessionId(): string {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY)
    if (existing) return existing

    const fresh = crypto.randomUUID()
    sessionStorage.setItem(SESSION_KEY, fresh)
    return fresh
  } catch {
    // Navegación privada con almacenamiento bloqueado: sesión efímera en memoria.
    return crypto.randomUUID()
  }
}

/** Clasificación gruesa del dispositivo, solo para segmentar la analítica. */
export function deviceType(): 'mobile' | 'tablet' | 'desktop' {
  if (typeof navigator === 'undefined') return 'desktop'
  const ua = navigator.userAgent
  if (/tablet|ipad/i.test(ua)) return 'tablet'
  if (/mobile|android|iphone/i.test(ua)) return 'mobile'
  return 'desktop'
}
